import { LoadingBoundary } from '@app/pages/i/components/LoadingBoundary';
import { BubbleItem } from '@app/types/shop-bff/types';
import Carousel from '@redbubble/design-system/src/Carousel';
import * as constants from '@redbubble/design-system/src/constants';
import Skeleton from '@redbubble/design-system/src/Skeleton';
import { useViewportWidth } from '@redbubble/next/hooks';
import { DeviceType } from '@redbubble/next/types';
import { kebabCase } from 'lodash';
import { TopicImageCard } from './TopicImageCard';

const MOBILE_CARD_DIMENSIONS = 160;
const DESKTOP_CARD_DIMENSIONS = 220;

interface TopicsCarouselProps {
  topics: BubbleItem[];
}

export const TopicImagesCarousel: React.FC<TopicsCarouselProps> = ({
  topics,
}) => {
  const { isOrAbove } = useViewportWidth();
  const isDesktop = isOrAbove(DeviceType.Desktop);

  const cardWidth = isDesktop
    ? DESKTOP_CARD_DIMENSIONS
    : MOBILE_CARD_DIMENSIONS;

  const uniqueKey = topics.reduce((acc, bubble) => {
    return `${acc}-${kebabCase(bubble.title)}`;
  }, '');

  return (
    <Carousel
      profile={isDesktop ? constants.DESKTOP : constants.MOBILE}
      slidesPerView="auto"
      key={uniqueKey}
    >
      {topics.map((topic) => (
        <div key={topic.title.split(' ').join('_')}>
          <LoadingBoundary
            loadingComponent={
              <Skeleton
                width={cardWidth}
                height={cardWidth}
                data-testid="topic-image-card-skeleton"
              />
            }
          >
            <TopicImageCard topic={topic} />
          </LoadingBoundary>
        </div>
      ))}
    </Carousel>
  );
};
